//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { environment } from 'src/environments/environment';
import { ExceptionsService } from './exceptions-service';
import { HttpClient, HttpContext, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })

export class HttpClientService {
  
  private authHeaderKey   : string;
  private authHeaderValue : string;
  private authHeaders     : HttpHeaders;
  private authOptions     : {};

  constructor(
    private exceptionsService: ExceptionsService,
    private httpClient       : HttpClient
  ) {
    this.authHeaderKey   = environment.webbingConfig.apiKeyName;
    this.authHeaderValue = environment.webbingConfig.apiKeyValue;
    this.authHeaders     = new HttpHeaders();
    this.authHeaders     = this.authHeaders.append(this.authHeaderKey, this.authHeaderValue);
    this.authOptions     = {headers : this.authHeaders}
  }

  public delete(path: string, id?: number): Observable<any> {
    try {
      return this.httpClient.delete(path + (id==undefined ? "" : id), this.authOptions);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public get<T>(path    : string,
                options?: {
                headers?: HttpHeaders;
                context?: HttpContext;
                observe?: 'body';
                params? : HttpParams | {
                  [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
                };
                reportProgress? : boolean;
                responseType?   : 'json';
                withCredentials?: boolean;
                transferCache?  : {
                  includeHeaders?: string[];
                } | boolean;
              }): Observable<T> {
    try {
      if (options == null) {
        options = this.authOptions;
      }
      else if (options.headers == null) {
        options.headers = this.authHeaders;
      }
      else {
        options.headers=options.headers.append(this.authHeaderKey, this.authHeaderValue);
      }

      return this.httpClient.get<T>(path, options);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getBlob(path: string): Observable<HttpResponse<Blob>> {
    try {
      return this.httpClient.get(path, {
        headers     : this.authHeaders,
        observe     : 'response',
        responseType: 'blob'
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getByDescription(path: string, description: string | undefined): Observable<any> {
    try {
      return this.httpClient.get<any>(path + (description==undefined ? "" : description), this.authOptions);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of(); 
    }
  }

  public getById(path: string, id: number | undefined): Observable<any> {
    try {
      return this.httpClient.get<any>(path + (id==undefined ? "" : id), this.authOptions);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public post(path: string, params: any, options?: any): Observable<any> {
    try {
        return this.httpClient.post<any>(path, params, this.authOptions);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public _post<T>(path: string, params: any, options?: any): Observable<any> {
    try {
        return this.httpClient.post<T>(path, params, this.authOptions);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public put(path: string, id: number | undefined, params: any, options?: any): Observable<any> {
    try {
      return this.httpClient.put<any>(path + (id==undefined ? "" : id), params, options ?? this.authOptions);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
